export const VERIFY_EMAIL_PATH = "verify-email";
